import HFHeader from "@/components/HFHeader";
import HFFooter from "@/components/HFFooter";
import { Container, SectionHeader } from "@/components/ui-hf";
import { DATENSCHUTZ, DATENSCHUTZ_DEFAULT } from "@/lib/legalContent";
import { useSiteContent } from "@/lib/siteContent";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Helmet } from "react-helmet-async";

/** Anker in Rechtstexten öffnen in neuem Tab mit `noopener noreferrer`. */
const MD_COMPONENTS = {
    a: ({ href, children, ...rest }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
        <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>{children}</a>
    ),
};

export default function DatenschutzPage() {
    const { get } = useSiteContent();
    // CMS-Wert bevorzugt; Fallback: 1:1-Default aus b-d-v.de.
    const markdown = (get<string>("legal.datenschutz", "").trim() || DATENSCHUTZ_DEFAULT).trim();
    const canonical =
        typeof window !== "undefined" ? `${window.location.origin}/datenschutz` : "/datenschutz";

    return (
        <div className="min-h-screen">
            <Helmet>
                <title>Datenschutzerklärung · HypeFly</title>
                <meta name="description" content="Datenschutzerklärung von HypeFly nach DSGVO." />
                <link rel="canonical" href={canonical} />
            </Helmet>
            <HFHeader />
            <main id="main-content" data-testid="datenschutz-main">
                <Container className="pt-16 md:pt-28 pb-20 md:pb-32 max-w-3xl">
                    {markdown ? (
                        <article className="prose max-w-none text-hf-ink" data-testid="datenschutz-markdown">
                            <ReactMarkdown remarkPlugins={[remarkGfm]} components={MD_COMPONENTS}>{markdown}</ReactMarkdown>
                        </article>
                    ) : (
                        <>
                            <SectionHeader eyebrow="Rechtliches" title={DATENSCHUTZ.title} lead={DATENSCHUTZ.intro} />
                            <div className="space-y-8 text-base leading-relaxed text-hf-ink">
                                {DATENSCHUTZ.sections.map((s) => (
                                    <section key={s.heading}>
                                        <h3 className="font-display text-xl md:text-2xl">{s.heading}</h3>
                                        <div className="mt-3 space-y-2 text-hf-muted">
                                            {s.body.map((line, j) => (
                                                <p key={j}>{line}</p>
                                            ))}
                                        </div>
                                    </section>
                                ))}
                            </div>
                        </>
                    )}
                </Container>
            </main>
            <HFFooter />
        </div>
    );
}
